const sizes = {
  9: '2.25rem',
  28: '7rem',
  container: { base: { sm: '576px', md: '768px', lg: '992px', xl: '1184px' } }
};

export default sizes;
